import { useEffect } from "react";
import ProjectsForm from "../components/ProjectsForm";
import { useNavigate, useParams } from "react-router-dom";
import { getProject2, useGetProject } from "../api/getProjects";
import { useGetAxe } from "../api";
import { findById } from "../../../utils/monthDiff";
import { useAxeSection } from "../../axes";
import { useSection } from "../../sections";
import { selectCurrentUser, selectToken } from "../../../auth/AuthUserSlice";
import { useSelector } from "react-redux";
import { CheckIfExist } from "../../../App";
import { ProjectDto } from "../types";
import { clients } from "../../../lib/axios";


const EditProjects = () => {

  const navigate = useNavigate();
  const currentUser = useSelector(selectCurrentUser); // preferred_username
  const token = useSelector(selectToken);
  
  const { id, axeId } = useParams();
  const { data: project } = useGetProject(id); 
  const { data: axe } = useGetAxe(project?.id ? project?.idAxe : axeId); 

  useEffect(() => {
    const check = async () => { 
      /**
       * Check if logged user has structure
       */
      try {

        const hasStructure = await CheckIfExist(currentUser?.preferred_username);
        if(!hasStructure) {
          navigate('/create/structure');
        }
      }catch(e) {
        console.log(e);
      }
    };

    check();

  }, [token]);
  
  return (
    <ProjectsForm defaultAxe={axe} defaultProject={project} />
  );
}
export default EditProjects;